export default __webpack_public_path__ + "static/media/DesktopLine1.a5ee55ab.svg";